<app-modal (onClose)="onClose.emit()" size="auth">
  <div class="auth__modal">
    @switch (authModalService.step | async) {
      @case (authModalService.authEnum.Login) {
        <app-login></app-login>
      }
      @case (authModalService.authEnum.SignUp) {
        <app-sign-up></app-sign-up>
      }
      @case (authModalService.authEnum.ForgetPassword) {
        <app-forget-password></app-forget-password>
      }
      @case (authModalService.authEnum.VerifyEmail) {
        <app-verify-email></app-verify-email>
      }
    }
    <br />
  </div>
</app-modal>
